<label class="form-label">{{ label }}</label>
<div class="row">
  <div class="col-auto">
    <app-background #background (change)="onChange()" label="Background"></app-background>
  </div>
  <div class="col">
    <app-font #font (change)="onChange()" label="Font"></app-font>
  </div>
</div>
